<template>
    <div>
        <el-breadcrumb separator="/">
            <el-breadcrumb-item>
                <span class="page-title">数据分析</span>
            </el-breadcrumb-item>
            <el-breadcrumb-item>用户资产统计</el-breadcrumb-item>
        </el-breadcrumb>

        <el-input v-model="queryParams.userId" placeholder="请输入用户ID" style="width: 400px"></el-input>
        <el-autocomplete class="inline-input" style="width: 200px"
                         v-model="queryParams.coinType"
                         :fetch-suggestions="querySearch"
                         placeholder="请输入币种">
            <i class="el-icon-close el-input__icon" slot="suffix"
               @click="cleanSearchCoin" style="cursor:pointer;">
            </i>
        </el-autocomplete>
        <el-button type="primary" @click="searchData" style="margin: 20px 0">搜 索</el-button>
        <el-button type="primary" @click="exportData" style="margin: 20px 20px">导 出</el-button>

        <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                  :data="dataList" :row-key="() => Math.random()">
            <el-table-column prop="coinType" label="币种"></el-table-column>
            <el-table-column prop="userId" label="用户ID"></el-table-column>
            <el-table-column prop="realName" label="KYC"></el-table-column>
            <el-table-column prop="totalAmount" label="总资产"></el-table-column>
            <el-table-column prop="coinAmount" label="可用资产"></el-table-column>
            <el-table-column prop="coinFroze" label="冻结资产"></el-table-column>
            <el-table-column label="创建时间">
                <template slot-scope="scope">
                    <span>{{scope.row.updateTime | moment}}</span>
                </template>
            </el-table-column>
            <el-table-column label="操作" width="300">
                <template slot-scope="scope">
                    <el-button type="primary" @click="accountAsset(scope.row)">账户资产</el-button>
                    <el-button type="primary" @click="frozeDetail(scope.row)">冻结明细</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination style="margin-top: 30px"
                       @size-change="handleSizeChange"
                       @current-change="handleCurrentChange"
                       :current-page="queryParams.page"
                       :page-sizes="[10, 20, 50, 100]"
                       :page-size="queryParams.size"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>

        <el-dialog title="账户资产" :visible.sync="dialogVisible" width="800px" @close="clearData"
                   :close-on-click-modal="false">
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}"
                      :data="assetDataList" :row-key="() => Math.random()">
                <el-table-column prop="walletTypeName" label="账户"></el-table-column>
                <el-table-column prop="totalAmount" label="账户总资产"></el-table-column>
                <el-table-column prop="coinAmount" label="可用资产"></el-table-column>
                <el-table-column prop="coinFroze" label="冻结资产"></el-table-column>
            </el-table>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="dialogVisible=false">关 闭</el-button>
            </span>
        </el-dialog>

        <el-dialog title="冻结明细" :visible.sync="frozenDialogVisible" width="1400px" @close="clearData"
                   :close-on-click-modal="false">
            <el-table border :header-cell-style="{background:'#FFF5F4',color:'#EC6D56'}" :data="frozenDataList"
                      :row-key="() => Math.random()">
                <el-table-column label="钱包账户">
                    <el-table-column prop="currentTreasure" label="活期宝"></el-table-column>
                    <el-table-column prop="timeTreasure" label="定期宝"></el-table-column>
                    <el-table-column label="staking(锁仓\解锁\冻结)">
                        <template slot-scope="scope">
                            <span>{{scope.row.staking}} \ {{scope.row.unStaking}} \ {{scope.row.frozeStaking}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="flexibleMining" label="灵活挖矿"></el-table-column>
                    <el-table-column prop="regularMining" label="定期挖矿"></el-table-column>
                    <el-table-column prop="newCoinMining" label="新币挖矿"></el-table-column>
                    <el-table-column prop="orderFreezing" label="下单冻结"></el-table-column>
                </el-table-column>
                <el-table-column label="法币账户">
                    <el-table-column prop="otcOrderFreezing" label="下单冻结"></el-table-column>
                </el-table-column>
                <el-table-column label="超级合约账户">
                    <el-table-column prop="contractOrderFreezing" label="下单冻结"></el-table-column>
                </el-table-column>
                <el-table-column label="永续合约账户">
                    <el-table-column prop="bnOrderFreezing" label="下单冻结"></el-table-column>
                </el-table-column>
            </el-table>

            <div style="color: #ffae28;margin-top: 10px">
                资产说明：<br>
                1.staking资产会从用户资产中扣除（非冻结）<br>
                2.表中展示数据为【（冻结资产：用户提交解锁，还未成功锁仓的资产，此时资产处于冻结状态）（锁仓资产：用户资产已扣除，进入Staking）（解锁中的资产：用户资产解锁，处于解锁周期，解锁未到账资产）】
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="frozenDialogVisible=false">关 闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import './store';
    import api from './api';

    export default {
        name: "UserAssetStatistics",
        data() {
            return {
                dataList: [],
                total: 0,
                queryParams: {
                    userId: "",
                    coinType: "",
                    page: 1,
                    size: 10
                },
                coinTypes: [],
                dialogVisible: false,
                frozenDialogVisible: false,
                assetDataList: [],
                frozenDataList: [],
            };
        },
        created() {
            this.getAllSupportCoin();
        },
        methods: {
            searchData() {
                this.queryParams.page = 1;
                this.getUserAssetPage();
            },
            getAllSupportCoin() {
                api.getAllSupportCoin().then(({data}) => {
                    this.coinTypes = data;
                });
            },
            getUserAssetPage() {
                if (this.queryParams.coinType == "") {
                    this.$message.error('请选择币种!');
                    return;
                }
                api.getUserAssetPage(this.queryParams).then(({data}) => {
                    this.dataList = data.records;
                    this.total = data.total;
                });
            },
            handleSizeChange(val) {
                this.queryParams.size = val;
                this.getUserAssetPage();
            },
            handleCurrentChange(val) {
                this.queryParams.page = val;
                this.getUserAssetPage();
            },
            exportData() {
                if (this.queryParams.coinType == "") {
                    this.$message.error('请选择币种!');
                    return;
                }
                api.exportUserAsset(this.queryParams).then(response => {
                    const fileName = "用户资产统计信息表.xlsx";
                    const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
                    if ('download' in document.createElement('a')) {
                        const link = document.createElement('a');
                        link.download = fileName;
                        link.style.display = 'none';
                        link.href = URL.createObjectURL(blob);
                        document.body.appendChild(link);
                        link.click();
                        URL.revokeObjectURL(link.href);
                    } else {
                        navigator.msSaveBlob(blob, fileName);
                    }
                })
            },
            accountAsset(row) {
                api.getUserAccountAsset({userId: row.userId, coinType: row.coinType}).then(({data}) => {
                    this.assetDataList = data;
                    this.dialogVisible = true;
                });
            },
            frozeDetail(row) {
                api.getUserAccountFrozeAsset({userId: row.userId, coinType: row.coinType}).then(({data}) => {
                    this.frozenDataList.push(data);
                    this.frozenDialogVisible = true;
                });
            },
            querySearch(queryString, cb) {
                var results = [];
                var coinList = this.coinTypes;
                results = queryString ? coinList.filter(this.createFilter(queryString)) : coinList;
                results = results.map((v, i, arr) => {
                    return {
                        value: v
                    }
                });
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                let tempData = this.coinTypes;
                return (tempData) => {
                    return (tempData.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
                };
            },
            cleanSearchCoin() {
                this.queryParams.coinType = '';
            },
            clearData() {
                this.assetDataList = [];
                this.frozenDataList = [];
            }
        }
    };
</script>

<style lang="less">
</style>
